import { SelectListItem } from "../../models/utilities/selectlist-item";

const ProvinceList = [
    {
        name: "Alberta",
        abbreviation: "AB"
    },
    {
        name: "British Columbia",
        abbreviation: "BC"
    },
    {
        name: "Manitoba",
        abbreviation: "MB"
    },
    {
        name: "New Brunswick",
        abbreviation: "NB"
    },
    {
        name: "Newfoundland and Labrador",
        abbreviation: "NL"
    },
    {
        name: "Northwest Territories",
        abbreviation: "NT"
    },
    {
        name: "Nova Scotia",
        abbreviation: "NS"
    },
    {
        name: "Nunavut",
        abbreviation: "NU"
    },
    {
        name: "Ontario",
        abbreviation: "ON"
    },
    {
        name: "Prince Edward Island",
        abbreviation: "PE"
    },
    {
        name: "Quebec",
        abbreviation: "QC"
    },
    {
        name: "Saskatchewan",
        abbreviation: "SK"
    },
    {
        name: "Yukon",
        abbreviation: "YT"
    }
];

const ProvinceSelectList = new Array<SelectListItem<string>>();
ProvinceList.forEach((itm: any) => {
    ProvinceSelectList.push(new SelectListItem({
        id: itm.abbreviation,
        name: itm.name
    }));
});

const ProvinceListDisplayNames: any = {};
ProvinceList.forEach((itm) => {
    ProvinceListDisplayNames[itm.abbreviation] = itm.name;
});

export { ProvinceSelectList, ProvinceListDisplayNames };
